import React, { useCallback, useState } from 'react';
import { useGetComponent } from 'hooks/useGetComponent';
import { componentIds } from 'utilities/constants';
import ModalComponent from 'components/modal/modalComponent';
import { ModalButtonProps } from 'components/modal/modal.interfaces';
import { useNavigate } from 'react-router-dom';
import { MY_ACCOUNT_PROFILE } from 'utilities/routes';
import { useCancelSubscriptionMutation } from 'graphql/generated/hasura';
import { useAuth } from 'auth/context/AuthContext';
import { ProviderProfileSectionTypes } from '../../../../enums';

interface CloseSubscriptionModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CloseSubscriptionModal: React.FC<CloseSubscriptionModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const { data: locale, loading: localeLoading } = useGetComponent({
    componentId: componentIds.CLOSE_SUBSCRIPTION_MODAL,
    locale: 'en',
  });
  const [fetch, setFetch] = useState(false);
  const { refetchSubscriptions } = useAuth();
  const navigate = useNavigate();
  const handeClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  const [cancelSubscriptions] = useCancelSubscriptionMutation({
    onCompleted: async () => {
      refetchSubscriptions && (await refetchSubscriptions());
      navigate(MY_ACCOUNT_PROFILE, {
        state: { section: ProviderProfileSectionTypes.BILLING_INFO },
      });
    },
  });

  const handleSubmit = () => {
    setFetch(true);
    return cancelSubscriptions().finally(() => setFetch(false));
  };

  const Buttons: ModalButtonProps[] = [
    {
      label: locale?.update,
      onClick: handleSubmit,
      showSpinner: fetch,
      disabled: fetch,
      testID: 'cancel-subscriptions',
    },
    {
      label: locale?.cancel,
      type: 'underline',
      testID: 'cancel',
      onClick: handeClose,
    },
  ];

  if (!locale || localeLoading) {
    return null;
  }

  return (
    <ModalComponent
      modalDesktopWidth="desktop:w-[600px]"
      buttons={Buttons}
      isOpen={isOpen}
      title={locale?.title}
      onClose={handeClose}
    >
      <p className="text-med-gray-3 font-medium">{locale?.text}</p>
    </ModalComponent>
  );
};

export default CloseSubscriptionModal;
